import notify from '../../Style-guide/ToastMessage';
import validateCourtInput from './validator';

const onSubmit = (props) => {
  const {
    images,
    courtInputs,
    courtData,
    schedule,
    updateCourt,
    setInputErrors,
    courtId,
    tr,
  } = props;

  const scheduleArray = Object.values(schedule);
  const isScheduleValid = scheduleArray.some((day) => day.isWorkingDay);

  if (!isScheduleValid) {
    notify.error(tr('schedule_required', { isError: true }));

    return;
  }

  const formData = new FormData();
  const errorFields = [];
  const checkUpload = (image) => image.src && image.src instanceof File;
  const checkDelete = (image) =>
    !image.src && !image.previewUrl && courtData?.[image.imageRole];

  images.forEach((file) => {
    if (checkUpload(file)) {
      formData.append(file.imageRole, file.src);
    }
    if (checkDelete(file)) {
      formData.append(file.imageRole, file.previewUrl);
    }
  });

  const { priceForSixtyMin, priceForNinetyMin } = courtInputs;

  Object.entries(courtInputs).forEach(([fieldName, value]) => {
    const { isValid, errorMessage, translationKey } = validateCourtInput({
      fieldName,
      value,
      relatedValues: { priceForSixtyMin, priceForNinetyMin },
    });

    if (!isValid) {
      setInputErrors((prev) => ({
        ...prev,
        [fieldName]: tr(translationKey, { isError: true }) || errorMessage,
      }));
      errorFields.push(fieldName);
    } else {
      setInputErrors((prev) => ({ ...prev, [fieldName]: '' }));
    }
  });

  if (errorFields.length === 0) {
    courtInputs.workingSchedule = schedule;

    Object.entries(courtInputs).forEach(([field, value]) => {
      if (typeof value === 'object') {
        formData.append(field, JSON.stringify(value)); // <-- serialize objects
      } else {
        formData.append(field, value);
      }
    });

    updateCourt({ data: formData, params: { id: courtId } });
  }
};

export default onSubmit;
